import React from 'react';
import { Field } from 'react-final-form';
import PhoneField from 'components/PhoneField';
import validations from 'validations';
import { Phone } from 'phoneNumberUtils';

type PhoneFieldWrapperProps = {
  name?: string;
  disabled?: boolean;
  required?: boolean;
  showInitialError?: boolean;
  verified?: boolean;
  verifiedElsewhere?: boolean;
  conflict?: boolean;
  limitReached?: boolean;
  onVerification?: () => void;
  onConfirmNumber?: () => void;
  onAddAnotherNumber?: () => void;
  isEqual?: (a?: Partial<Phone>, b?: Partial<Phone>) => boolean;
};

const PhoneFieldWrapper: React.FC<PhoneFieldWrapperProps> = (props) => {
  const {
    name = 'phone',
    disabled = false,
    required = false,
    showInitialError = false,
    verified = false,
    verifiedElsewhere = false,
    conflict = false,
    limitReached = false,
    onVerification,
    onConfirmNumber,
    onAddAnotherNumber,
    ...rest
  } = props;

  return (
    <Field
      {...rest}
      name={name}
      component={PhoneField}
      disabled={disabled}
      required={required}
      showInitialError={showInitialError}
      verified={verified}
      verifiedElsewhere={verifiedElsewhere}
      conflict={conflict}
      limitReached={limitReached}
      onVerification={onVerification}
      onConfirmNumber={onConfirmNumber}
      onAddAnotherNumber={onAddAnotherNumber}
      validate={validations.composeValidators(
        required ? validations.phoneRequired() : null,
        validations.phone(),
      )}
    />
  );
};

export default PhoneFieldWrapper;
